<script setup lang="ts">
import UiButton from "~/components/ui/Button.vue";

const props = defineProps({
  modelValue: {
    type: Number,
    required: true,
  },
  totalPages: {
    type: Number,
    required: true,
  },
});
const emit = defineEmits(["update:modelValue"]);

const nextPage = (): void => {
  if (props.modelValue < props.totalPages - 1) {
    emit("update:modelValue", props.modelValue + 1);
  }
};

const previousPage = (): void => {
  if (props.modelValue > 0) {
    emit("update:modelValue", props.modelValue - 1);
  }
};
</script>

<template>
  <div class="pagination">
    <UiButton type="secondary" variant="solid" @click="previousPage" icon="material-symbols:arrow-left-rounded" name="Předchozí strana" />
    <span>{{ modelValue + 1 }} / {{ totalPages }}</span>
    <UiButton type="secondary" variant="solid" @click="nextPage" icon="material-symbols:arrow-right-rounded" name="Další strana" />
  </div>
</template>

<style scoped lang="scss">
.pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  font-size: 18px;
  color: rgb(var(--text-light-color));
}
</style>